import { jsx as r, Fragment as o } from "react/jsx-runtime";
import { forwardRef as t } from "react";
const f = t(() => /* @__PURE__ */ r(o, {}));
export {
  f as Hidden
};
//# sourceMappingURL=Hidden.js.map
